import fetcher from '../API';
import CategoryUtils from '../common/CategoryUtils';

const FETCH_CATEGORY_TREE = 'FETCH_CATEGORY_TREE';
export const FETCH_CATEGORY_TREE_FULFILLED = 'FETCH_CATEGORY_TREE_FULFILLED';
export const FETCH_CATEGORY_TREE_REJECTED = 'FETCH_CATEGORY_TREE_REJECTED';
export const SELECTED_CATEGORY = 'SELECTED_CATEGORY';
export const FILTER_CAT_TREE = 'FILTER_CAT_TREE';

export const fetchCategoryTree = () => {
    return (dispatch) => {
        // Redux thunk: https://github.com/gaearon/redux-thunk
        dispatch({ type: FETCH_CATEGORY_TREE });
        // v2 will return a tree-structured categories list
        fetcher.get('api/v2/productcategories')
            .then((responese) => {
                // Save the tree data for general use
                if (responese.data) {
                    CategoryUtils.saveCategoryTree(responese.data);
                    responese.data.children.push({
                      category: {
                          id:'other',
                          displayTerm:'other',
                          term:'other',
                      }
                  }) 
                }
                dispatch({
                    type: FETCH_CATEGORY_TREE_FULFILLED,
                    payload: responese.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_CATEGORY_TREE_REJECTED,
                    payload: `${error}`
                });
            });
    };
}

export const selectCategory = (selectedCategories) => {
    return {
        type: SELECTED_CATEGORY,
        payload: selectedCategories
    }
}

export const filterCategoryTree = (searchTerm) => {
    let catTree = CategoryUtils.loadCategoryTree();
    let filteredCatTree = JSON.parse(JSON.stringify(catTree));
    filteredCatTree = recursiveFilter(filteredCatTree, searchTerm);
    if(filteredCatTree === null){
      catTree.children = [];
      filteredCatTree = catTree;
    }
    return {
      type: FILTER_CAT_TREE,
      payload: filteredCatTree
    }
  }
  
function recursiveFilter(node, searchTerm){
    if(node.category.id && node.category.id.startsWith(searchTerm))return node;
    if(node.category.term && node.category.term.includes(searchTerm)) return node;
    if(node.category.displayTerm && node.category.displayTerm.includes(searchTerm)) return node;
  
    //if is at end node and doesnt match
    if(!node.children){
      return null;
    }
    //if there are children and doesnt match
    else{
      var tempArr = [];
      //for each children check if matches, and if so add it to a temp array
      for(var i = 0; i<node.children.length; i++){
        var temp2 = recursiveFilter(node.children[i], searchTerm);
        //if the child node matches
        if(temp2 != null){
          tempArr.push(node.children[i]);
        }
      }
    }
  
    //if none of the children have a match, the node is deleted
    if(tempArr.length < 1){
      return null;
    }
    else{
      //otherwise return the node with all matching children
      node.children = tempArr;
      return node;
    }
  
}